/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Meta_TitleInputs */

const en_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessons | Mark Egly Golf`)
};

const es_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecciones | Mark Egly Golf`)
};

const de_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunden | Mark Egly Golf`)
};

const zh_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`课程 | Mark Egly Golf`)
};

const ar_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الدروس | Mark Egly Golf`)
};

const fr_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leçons | Mark Egly Golf`)
};

const vi_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài học | Mark Egly Golf`)
};

const sw_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo | Mark Egly Golf`)
};

const th_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บทเรียน | Mark Egly Golf`)
};

const bs_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcije | Mark Egly Golf`)
};

const ja_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスン | Mark Egly Golf`)
};

const ko_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 | Mark Egly Golf`)
};

const pt_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas | Mark Egly Golf`)
};

const it_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni | Mark Egly Golf`)
};

const sv_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner | Mark Egly Golf`)
};

const nl_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lessen | Mark Egly Golf`)
};

const da_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lektioner | Mark Egly Golf`)
};

const nb_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leksjoner | Mark Egly Golf`)
};

const fi_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppitunnit | Mark Egly Golf`)
};

const pl_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekcje | Mark Egly Golf`)
};

const ru_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уроки | Mark Egly Golf`)
};

const tr_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dersler | Mark Egly Golf`)
};

const hi_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ | Mark Egly Golf`)
};

const id_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran | Mark Egly Golf`)
};

const ms_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajaran Persendirian | Mark Egly Golf`)
};

const cs_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lekce | Mark Egly Golf`)
};

const el_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μαθήματα | Mark Egly Golf`)
};

const he_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעורים | Mark Egly Golf`)
};

const af_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesse | Mark Egly Golf`)
};

const hu_lessons_meta_title = /** @type {(inputs: Lessons_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leckék | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Lessons \| Mark Egly Golf" |
*
* @param {Lessons_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_meta_title = /** @type {((inputs?: Lessons_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_meta_title(inputs)
	if (locale === "de") return de_lessons_meta_title(inputs)
	if (locale === "zh") return zh_lessons_meta_title(inputs)
	if (locale === "ar") return ar_lessons_meta_title(inputs)
	if (locale === "fr") return fr_lessons_meta_title(inputs)
	if (locale === "vi") return vi_lessons_meta_title(inputs)
	if (locale === "sw") return sw_lessons_meta_title(inputs)
	if (locale === "th") return th_lessons_meta_title(inputs)
	if (locale === "bs") return bs_lessons_meta_title(inputs)
	if (locale === "ja") return ja_lessons_meta_title(inputs)
	if (locale === "ko") return ko_lessons_meta_title(inputs)
	if (locale === "pt") return pt_lessons_meta_title(inputs)
	if (locale === "it") return it_lessons_meta_title(inputs)
	if (locale === "sv") return sv_lessons_meta_title(inputs)
	if (locale === "nl") return nl_lessons_meta_title(inputs)
	if (locale === "da") return da_lessons_meta_title(inputs)
	if (locale === "nb") return nb_lessons_meta_title(inputs)
	if (locale === "fi") return fi_lessons_meta_title(inputs)
	if (locale === "pl") return pl_lessons_meta_title(inputs)
	if (locale === "ru") return ru_lessons_meta_title(inputs)
	if (locale === "tr") return tr_lessons_meta_title(inputs)
	if (locale === "hi") return hi_lessons_meta_title(inputs)
	if (locale === "id") return id_lessons_meta_title(inputs)
	if (locale === "ms") return ms_lessons_meta_title(inputs)
	if (locale === "cs") return cs_lessons_meta_title(inputs)
	if (locale === "el") return el_lessons_meta_title(inputs)
	if (locale === "he") return he_lessons_meta_title(inputs)
	if (locale === "af") return af_lessons_meta_title(inputs)
	if (locale === "hu") return hu_lessons_meta_title(inputs)
	return en_lessons_meta_title(inputs)
});